import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutPage } from '@layout/app.layout.page';
import { authGuardFn } from '@shared/guards/auth.guard';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { DashboardPage } from '@dashboard/dashboard.page';
import { roleGuardFn } from './shared/guards/role.guard';
import { RoleMatch } from './shared/enums/role-match.enum';
import { NotImplementedComponent } from './shared/components/not-implemented/not-implemented.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
        {
          path: 'app',
          canActivate: [authGuardFn],
          component: AppLayoutPage,
          children: [
            {
              path: 'clients',
              canActivate: [roleGuardFn],
              loadChildren: () => import('./client/client.module').then(m => m.ClientModule),
              data: {
                breadcrumbs: {
                  label: $localize`clienti`,
                },
              },
            },
            {
              path: 'dashboard',
              component: DashboardPage,
            },
            {
              path: 'exercises',
              canActivate: [roleGuardFn],
              loadChildren: () => import('./exercise/exercise.module').then(m => m.ExerciseModule),
              data: {
                breadcrumbs: {
                  label: $localize`esercizi`,
                },
              },
            },
            {
              path: 'tags',
              canActivate: [roleGuardFn],
              loadChildren: () => import('./tag/tag.module').then(m => m.TagModule),
              data: {
                breadcrumbs: {
                  label: $localize`tag`,
                },
              },
            },
            {
              path: 'members',
              canActivate: [roleGuardFn],
              loadChildren: () => import('./member/member.module').then(m => m.MemberModule),
              data: {
                breadcrumbs: {
                  label: $localize`pazienti`,
                },
              },
            },
            {
              path: 'profile',
              loadChildren: () => import('@profile/profile.module').then(m => m.ProfileModule),
              data: {
                breadcrumbs: {
                  label: $localize`profilo`,
                },
              },
            },
            {
              path: 'stations',
              canActivate: [roleGuardFn],
              loadChildren: () => import('./station/station.module').then(m => m.StationModule),
              data: {
                breadcrumbs: {
                  label: $localize`dispositivi`,
                },
              },
            },
            {
              path: 'programs',
              canActivate: [roleGuardFn],
              loadChildren: () => import('./program/program.module').then(m => m.ProgramModule),
              data: {
                breadcrumbs: {
                  label: $localize`Terapie`,
                },
              },
            },
            {
              path: 'sessions',
              canActivate: [roleGuardFn],
              loadChildren: () => import('./session/session.module').then(m => m.SessionModule),
              data: {
                breadcrumbs: {
                  label: $localize`sessioni`,
                },
              },
            },
            {
              path: 'users',
              canActivate: [roleGuardFn],
              loadChildren: () => import('./user/user.module').then(m => m.UserModule),
              data: {
                breadcrumbs: {
                  label: $localize`utenti`,
                },
              },
            },
            {
              path: '',
              pathMatch: 'full',
              redirectTo: 'dashboard',
            },
          ],
        },
        { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
        { path: 'not-found', component: NotFoundComponent },
        { path: 'not-implemented', component: NotImplementedComponent },
        { path: '', pathMatch: 'full', redirectTo: 'app' },
        { path: '**', redirectTo: '/not-found' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        bindToComponentInputs: true,          // Routing data can be bound to component input params
        paramsInheritanceStrategy: 'always',  // forward routing params to child routes
        onSameUrlNavigation: 'reload',        // force reload when navigating to the current route
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
